import React, { useEffect, useState } from 'react'
import cn from 'classnames'
import { Tooltip } from '@material-ui/core'
import { injectIntl } from 'react-intl'
import { connect } from 'react-redux'
import { ReactComponent as DuplicateIcon } from 'assets/img/duplicate.svg'
import { ReactComponent as ArrowRight } from 'assets/img/arrow-right.svg'
import {
  fetchProjectedSitesManagerSnapshots,
  updateProjectedSitesManagerSnapshot,
  fetchProjectedSitesManagerUsersAndGroups,
} from 'reducers/projectedSitesManager/reducer'
import withPromise from 'helpers/withPromise'
import CircleLoader from 'components/Loading/CircleLoader'
import ConfirmDialog from 'components/common/Popup/ConfirmDialog'
import { StyledIconWrap } from 'components/common/Inputs/styles'
import {
  StyledModal,
  StyledModalBoxSection,
  StyledModalOverlay,
  StyledModalCloseButton,
  StyledFormSection,
  StyledModalTitle,
} from 'components/common/Modals/styles'
import { Flex } from 'components/common/styles'
import messages from '../translate'
import SingleSnapshot from './SingleSnapshot'
import { StyledTable } from '../ProjectedSitesManager.styles'

function SnapshotsManagerMenu({
  intl: { formatMessage },
  projectedSitesManagerAdmin,
  isModalOpened,
  handleCloseModal,
  isLoadSnapshots,
  snapshots,
  fetchProjectedSitesManagerSnapshots,
  updateProjectedSitesManagerSnapshot,
  fetchProjectedSitesManagerUsersAndGroups,
  selectedSiteType,
  selectedSnapshot,
  setSnapshot,
}) {
  const snapshotsList = snapshots.toJS()
  const isMainTable = selectedSnapshot === 'main-table'

  const [snapshotToDelete, setSnapshotToDelete] = useState(null)

  useEffect(() => {
    if (projectedSitesManagerAdmin) {
      fetchProjectedSitesManagerUsersAndGroups()
    }

    fetchProjectedSitesManagerSnapshots()
  }, [])

  const onDuplicateMainSnapshot = () => {
    withPromise(fetchProjectedSitesManagerSnapshots, {
      method: 'POST',
    }).then(() => {
      fetchProjectedSitesManagerSnapshots()
    })
  }

  const onUpdateSnapshot = ({ id, method }) => {
    withPromise(updateProjectedSitesManagerSnapshot, {
      id,
      method,
    }).then(() => {
      fetchProjectedSitesManagerSnapshots()
    })
  }

  return (
    <>
      <StyledModalOverlay
        className={cn({ closed: !isModalOpened })}
        onClick={handleCloseModal}
      />
      <StyledModal
        opened={isModalOpened}
        direction="column"
        customWidth="860px">
        <StyledFormSection>
          <StyledModalBoxSection>
            <Flex align="center" justify="space-between">
              <StyledModalTitle>
                {formatMessage(messages.tablesManagement)}
              </StyledModalTitle>
              <StyledModalCloseButton onClick={handleCloseModal} />
            </Flex>
          </StyledModalBoxSection>
          <StyledModalBoxSection noBorder>
            <StyledTable direction="column">
              <thead>
                <tr>
                  <th>{formatMessage(messages.name)}</th>
                  <th>{formatMessage(messages.created)}</th>
                  <th>{formatMessage(messages.modified)}</th>
                  {projectedSitesManagerAdmin && (
                    <th>{formatMessage(messages.permission)}</th>
                  )}
                  <th>{formatMessage(messages.actions)}</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>{formatMessage(messages.mainTable)}</td>
                  <td />
                  <td />
                  {projectedSitesManagerAdmin && <td />}
                  <td>
                    <Flex>
                      {projectedSitesManagerAdmin && (
                        <StyledIconWrap onClick={onDuplicateMainSnapshot}>
                          <Tooltip
                            placement="top"
                            title={formatMessage(messages.duplicate)}>
                            <DuplicateIcon />
                          </Tooltip>
                        </StyledIconWrap>
                      )}
                      <StyledIconWrap
                        disabled={isMainTable}
                        onClick={() => {
                          if (!isMainTable) {
                            setSnapshot(null, selectedSiteType, 'main-table')
                            handleCloseModal()
                          }
                        }}>
                        <ArrowRight />
                      </StyledIconWrap>
                    </Flex>
                  </td>
                </tr>
                {snapshotsList.map(snapshotData => (
                  <SingleSnapshot
                    {...snapshotData}
                    key={snapshotData.id}
                    setSnapshotToDelete={setSnapshotToDelete}
                    onUpdateSnapshot={onUpdateSnapshot}
                    handleCloseModal={handleCloseModal}
                    selectedSiteType={selectedSiteType}
                    selectedSnapshot={selectedSnapshot}
                    setSnapshot={setSnapshot}
                  />
                ))}
              </tbody>
            </StyledTable>
          </StyledModalBoxSection>
        </StyledFormSection>
      </StyledModal>
      <ConfirmDialog
        open={snapshotToDelete}
        title={formatMessage(messages.deleteSnapshot)}
        className="confirm-action dialog-primary-custom"
        message={formatMessage(messages.deleteSnapshotConfirmationMessage)}
        onConfirmAction={() => {
          setSnapshotToDelete(null)
          onUpdateSnapshot({
            id: snapshotToDelete,
            method: 'DELETE',
          })
        }}
        onClose={() => setSnapshotToDelete(null)}
        confirm={{
          color: 'new-primary',
        }}
        cancel={{
          color: 'default',
          variant: 'outlined',
        }}
      />
      <CircleLoader loading={isLoadSnapshots} />
    </>
  )
}

export default connect(
  state => ({
    projectedSitesManagerAdmin: state.getIn([
      'profile',
      'profile',
      'projectedSitesManagerAdmin',
    ]),
    snapshots: state.getIn(['projectedSitesManager', 'snapshots']),
    isLoadSnapshots: state.getIn(['projectedSitesManager', 'isLoadSnapshots']),
  }),
  {
    fetchProjectedSitesManagerSnapshots,
    updateProjectedSitesManagerSnapshot,
    fetchProjectedSitesManagerUsersAndGroups,
  },
)(injectIntl(SnapshotsManagerMenu))
